import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/national-team")({
  component: () => <Outlet />,
});
